jQuery(document).ready(function () {

  // Remove controls from video shortcode videos.
  jQuery('.wp-video-shortcode video').removeAttr('controls');

  jQuery(".accordion-content").on("show.bs.collapse", function () {
    // var id = jQuery(this).attr("data-service-id");

    // Hide all asides
    //jQuery(".card-aside").removeClass('inplace');

    // Show this aside
    //jQuery("#card-aside-" + id).addClass('inplace');

    var element_id = jQuery(this).attr("id");
    console.log(element_id);
    // This accordion
    var this_accordion_id = jQuery(this).attr("data-parent"); // has hash

    // Fidn the parent card and add active to it.
    jQuery(this_accordion_id + " .card").removeClass("active");
    jQuery(this_accordion_id + " .card").removeClass("inplace");
    jQuery("#" + element_id)
      .parent()
      .parent()
      .addClass("active");

    // Add inplace after .2 seconds
    setTimeout(function () {
      jQuery("#" + element_id)
        .parent()
        .parent()
        .addClass("inplace");
    }, 220);
  });

  // Add data-featherlight="image" to the first link in each grid item.

  jQuery(".lightbox-grid").each(function (index, element) {
    jQuery(element)
      .find(".grid-item")
      .each(function (index2, element2) {
        // Do something with each inner element
        jQuery(element2).find("a").first().attr("data-featherlight", "image");
      });
  });

  // Close the nav window when someone clicks off it.
  jQuery(document).on("click", function (e) {
    const $menu = jQuery(".navbar-container.showing.show");
    const $navbar = jQuery("nav.navbar");
    const $navbar_toggler = jQuery(".navbar-toggler");

    // If click target is outside both elements...
    if (
      !$menu.is(e.target) &&
      $menu.has(e.target).length === 0 &&
      !$navbar.is(e.target) &&
      $navbar.has(e.target).length === 0 &&
      !$navbar_toggler.is(e.target) &&
      $navbar_toggler.has(e.target).length === 0
    ) {
      jQuery(".navbar-container").removeClass("show");
      jQuery(".navbar-toggler").removeClass("show");

      jQuery("#bs4navbar").collapse("hide");

      jQuery("html").removeClass("show-nav");
      jQuery("body").removeClass("no-scroll");
      setTimeout(function () {
        jQuery(".navbar-container").removeClass("showing");
        jQuery(".navbar-toggler").removeClass("showing");
        jQuery("html").removeClass("showing-nav");
        jQuery("html").removeClass("fade-nav");
      }, 100);
    }
  });

  /*
  jQuery(".youtube-autoplay iframe").each(function () {
    var iframe = jQuery(this);
    var src = iframe.attr("src");

    // Build URL safely with query params
    var url = new URL(src);
    url.searchParams.set("autoplay", "1");
    url.searchParams.set("mute", "1");
    url.searchParams.set("controls", "0");
    url.searchParams.set("loop", "1"); // optional, allows loop
    url.searchParams.set("playlist", url.pathname.split("/").pop()); // required for looping to work
    url.searchParams.set("modestbranding", "1");
    url.searchParams.set("rel", "0"); // only show related videos from same channel

    iframe.attr("src", url.toString());
  });
  */

  jQuery(function () {
    jQuery(".envira-video-in-gallery video").each(function () {
      var $vid = jQuery(this);

      // Ensure correct playback attributes
      $vid.attr({
        autoplay: true,
        muted: true,
        loop: true,
        playsinline: true,
      });

      console.log('autoplaing video.');

      // Remove any controls
      $vid.prop("controls", false).removeAttr("controls");

      this.play().catch(function () {});

      // Start playback once metadata is ready
      $vid.on("loadedmetadata", function () {
        this.play().catch(function () {});
      });
    });
  });
});

